import React, { useEffect, useState } from "react";
import Style from "../../style/travelpopular.module.scss";
const AgencyImage = [
  "https://www.snaptours.in/blog/wp-content/uploads/2021/12/2-840x473.jpg",
  "https://selzy.com/en/blog/wp-content/uploads/2022/08/email-marketing-for-travel-agents_1200.png",
  "https://static.vecteezy.com/system/resources/thumbnails/003/168/649/small/miniature-toy-airplane-flying-on-cloud-blue-sky-background-free-photo.jpg",
  "https://cdn.prod.website-files.com/65e76740607a710e8e5a7d0f/662c09367f8ef4db2e8fbe71_razones-agencia-de-viajes-corporativos.jpeg.webp",
];

const TravelPopular = () => {
  const [data, setData] = useState<any | []>([]);
  useEffect(() => {
    fetch("/data/travel.json")
      .then((value) => {
        return value.json();
      })
      .then((res) => {
        setData(res.agencies);
      });
  }, []);

  return (
    <div className={Style.container}>
      <div className={Style.title}>
        <h2>Leading Travel Providers</h2>
      </div>
      <div className={Style.mainbox}>
        {[...data]
          .sort((a, b) => b.rating - a.rating)
          .slice(0, 4)
          .map((item: any, index: number) => (
            <a
              href={item.website}
              key={index}
              target="_blank"
              rel="noopener noreferrer"
              className={Style.card}
            >
              <img
                src={AgencyImage[index % AgencyImage.length]}
                alt={item.name}
              />
              <h2>{item.name}</h2>
              <h3>
                <i className="fa-solid fa-location-dot"></i>
                <span>{item.address}</span>
              </h3>
            </a>
          ))}
      </div>
    </div>
  );
};

export default TravelPopular;
